import React, { useEffect } from "react";
import { Dialog, Box, Typography } from "@mui/material";
import styles from "./teenpatiTtweentyresultspopup.module.css";

import { useDispatch, useSelector } from "react-redux";
import { TwoTweentyTeenPattiResult } from "../../../store/slices/casinoResultsSlice";

/*
========================================
PARSE SINGLE CARD
KC => K ♣
6D => 6 ♦
3H => 3 ♥
========================================
*/

const parseCard = (cardStr = "") => {
  if (!cardStr) {
    return {
      value: "-",
      suit: "",
      isRed: false,
    };
  }

  const raw = cardStr.trim().toUpperCase();

  const suitMap = {
    H: "♥",
    D: "♦",
    C: "♣",
    S: "♠",
  };

  const suitCode = raw.slice(-1);

  const value = raw.slice(0, -1);

  const suit = suitMap[suitCode] || "";

  return {
    value,
    suit,
    isRed: suit === "♥" || suit === "♦",
  };
};

/*
========================================
CONVERT:
"[KC, 6D, 3H]"
TO:
["KC", "6D", "3H"]
========================================
*/

const parseHand = (handString = "") => {
  if (!handString) return [];

  return handString
    .replace("[", "")
    .replace("]", "")
    .split(",")
    .map((item) => item.trim());
};

const CloseSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_close)">
      <path
        d="M0.586047 12.0001C0.470144 12.0001 0.356837 11.9657 0.26046 11.9014C0.164083 11.837 0.0889654 11.7455 0.0446082 11.6384C0.000250996 11.5313 -0.0113527 11.4135 0.0112649 11.2998C0.0338824 11.1861 0.0897052 11.0817 0.171672 10.9998L10.9998 0.17164C11.1097 0.0617407 11.2588 0 11.4142 0C11.5696 0 11.7186 0.0617407 11.8285 0.17164C11.9384 0.281539 12.0002 0.430594 12.0002 0.586015C12.0002 0.741436 11.9384 0.890491 11.8285 1.00039L1.00042 11.8285C0.946056 11.883 0.881462 11.9262 0.810351 11.9556C0.739239 11.9851 0.663012 12.0002 0.586047 12.0001Z"
        fill="white"
      />
      <path
        d="M11.4141 12.0001C11.3372 12.0002 11.2609 11.9851 11.1898 11.9556C11.1187 11.9262 11.0541 11.883 10.9998 11.8285L0.17164 1.00039C0.0617407 0.890491 0 0.741436 0 0.586015C0 0.430594 0.0617407 0.281539 0.17164 0.17164C0.281539 0.0617407 0.430594 0 0.586015 0C0.741436 0 0.890491 0.0617407 1.00039 0.17164L11.8285 10.9998C11.9105 11.0817 11.9663 11.1861 11.9889 11.2998C12.0115 11.4135 11.9999 11.5313 11.9556 11.6384C11.9112 11.7455 11.8361 11.837 11.7397 11.9014C11.6433 11.9657 11.53 12.0001 11.4141 12.0001Z"
        fill="white"
      />
    </g>

    <defs>
      <clipPath id="clip0_close">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const TrophySVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 41 40"
    fill="none"
  >
    <path
      d="M23.2038 15.5799L23.7874 18.9815L20.733 17.3755L17.6786 18.9815L18.2622 15.5799L15.791 13.1719L19.2058 12.6751L20.733 9.58105L22.2602 12.6751L25.675 13.1719L23.2038 15.5799Z"
      fill="#128400"
    />
    <path
      d="M26.2665 31.0526H15.2441C19.2745 29.0374 18.4809 24.6298 18.5605 25.1266L18.7933 25.169C19.0556 25.2549 19.3227 25.325 19.5933 25.379C19.9639 25.4535 20.3395 25.5006 20.7169 25.5198L20.7357 25.5234H20.7553H20.7749L20.7909 25.5206C21.169 25.5014 21.5452 25.4546 21.9165 25.3806C22.2539 25.313 22.5858 25.2207 22.9097 25.1046C22.8901 25.3694 22.5881 29.213 26.2665 31.0526Z"
      fill="#128400"
    />
    <path
      d="M27.076 32.09V35.0212H14.4336V32.09C14.4336 31.9561 14.46 31.8236 14.5112 31.6999C14.5625 31.5762 14.6376 31.4638 14.7323 31.3692C14.8269 31.2745 14.9393 31.1995 15.063 31.1483C15.1867 31.0971 15.3193 31.0707 15.4532 31.0708H26.0564C26.1903 31.0707 26.3228 31.0971 26.4465 31.1483C26.5702 31.1995 26.6827 31.2745 26.7773 31.3692C26.872 31.4638 26.9471 31.5762 26.9984 31.6999C27.0496 31.8236 27.076 31.9561 27.076 32.09Z"
      fill="#28D225"
    />
    <path
      d="M30.6342 6.9574C30.6238 6.2978 30.6126 5.6374 30.6126 4.979H10.8986C10.8986 5.6378 10.8874 6.299 10.8774 6.9574C10.8426 9.1574 10.815 11.3546 11.2306 13.5226C11.4309 14.5861 11.6913 15.6374 12.0106 16.6714C12.4146 17.9666 12.9266 19.2266 13.5798 20.4098C14.7482 22.5298 16.4742 24.4134 18.7938 25.1698L20.7174 25.5202L20.7574 25.5226H20.793L22.913 25.0914C25.1338 24.3074 26.7962 22.4682 27.9306 20.4098C29.1066 18.2802 29.825 15.903 30.281 13.5226C30.6962 11.3546 30.6686 9.1574 30.6342 6.9574ZM23.7882 18.9814L20.7338 17.3758L17.6794 18.9814L18.263 15.5814L15.7918 13.173L19.2066 12.677L20.7338 9.5826L22.261 12.677L25.6758 13.173L23.2046 15.5802L23.7882 18.9814Z"
      fill="#28D225"
    />
  </svg>
);

/*
========================================
CARD UI
========================================
*/

const RenderCards = ({ title, cards, color }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          color,
          fontWeight: 700,
          fontSize: "18px",
          mb: 2,
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        {cards.map((card, index) => {
          const parsed = parseCard(card);

          return (
            <Box key={index} className={styles.Cards_container}>
              <Typography
                className={styles.Cards_number}
                sx={{
                  color: parsed.isRed ? "#e00" : "#111",
                }}
              >
                {parsed.value}
              </Typography>

              <Typography
                sx={{
                  color: parsed.isRed ? "#e00" : "#111",
                  fontSize: "28px",
                }}
              >
                {parsed.suit}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

const TeenPatiTtweentyResultPopup = ({ open, onClose, resultData }) => {
  const dispatch = useDispatch();

  const reduxData = useSelector(
    (state) => state.casinoResults.TwoTweentyTeenPatti,
  );
      const formatMatchTime = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const pad = (n) => String(n).padStart(2, '0');

  const day = pad(d.getDate());
  const month = pad(d.getMonth() + 1);
  const year = d.getFullYear();
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());
  const seconds = pad(d.getSeconds());

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

  /*
    ========================================
    API CALL
    ========================================
    */

  useEffect(() => {
    if (open && resultData?.roundId) {
      dispatch(TwoTweentyTeenPattiResult(resultData.roundId));
    }
  }, [open, resultData?.roundId, dispatch]);

  /*
    ========================================
    API DATA
    ========================================
    */

  const apiData = resultData || reduxData?.data || reduxData || {};

  /*
    ========================================
    PLAYER HANDS
    ========================================
    */

  const playerACards = parseHand(apiData?.player1Hand);

  const playerBCards = parseHand(apiData?.player2Hand);

  /*
    ========================================
    WINNER
    ========================================
    */

  const winner = apiData?.winner || "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={styles.betDialogOpen_container}
      PaperProps={{
        style: {
          position: "absolute",
          top: 47,
          width: "100%",
          maxWidth: "500px",
          borderRadius: "0px",
          margin: 0,
        },
      }}
    >
      <Box className={styles.Dialog_header}>
        <Typography className={styles.betDialog_header_txt}>
          Teen Patti T20
        </Typography>
        <span
          onClick={onClose}
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          <CloseSVG />
        </span>
      </Box>

      <Box className={styles.Dialog_body}>
        {/* Round Info */}
        <Box className={styles.roundId_TextField_container}>
          <Typography sx={{ fontSize: "12px", color: "#333" }}>
            Round Id: <strong>{apiData?.roundId || resultData?.roundId}</strong>
          </Typography>
          <Typography sx={{ fontSize: "12px", color: "#333" }}>
  Match Time: <strong>{formatMatchTime(apiData?.settledAt)}</strong>
</Typography>
        </Box>

        {/* Players Side by Side */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "8px",
            padding: "8px 0",
          }}
        >
          {/* Player A */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <Typography
              sx={{ fontSize: "13px", fontWeight: 700, color: "#1976d2" }}
            >
              Player A
            </Typography>
            <Box sx={{ display: "flex", gap: "4px", justifyContent: "center" }}>
              {playerACards.map((card, i) => {
                const parsed = parseCard(card);
                return (
                  <Box key={i} className={styles.Cards_container}>
                    <Typography
                      className={styles.Cards_number}
                      sx={{ color: parsed.isRed ? "#e00" : "#111" }}
                    >
                      {parsed.value}
                    </Typography>
                    <Typography
                      sx={{
                        color: parsed.isRed ? "#e00" : "#111",
                        fontSize: "18px",
                        lineHeight: 1,
                      }}
                    >
                      {parsed.suit}
                    </Typography>
                  </Box>
                );
              })}
              {winner === "PLAYER_A" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <TrophySVG />
                </Box>
              )}
            </Box>
          </Box>

          {/* Player B */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <Typography
              sx={{ fontSize: "13px", fontWeight: 700, color: "#d32f2f" }}
            >
              Player B
            </Typography>
            <Box sx={{ display: "flex", gap: "4px", justifyContent: "center" }}>
              {playerBCards.map((card, i) => {
                const parsed = parseCard(card);
                return (
                  <Box key={i} className={styles.Cards_container}>
                    <Typography
                      className={styles.Cards_number}
                      sx={{ color: parsed.isRed ? "#e00" : "#111" }}
                    >
                      {parsed.value}
                    </Typography>
                    <Typography
                      sx={{
                        color: parsed.isRed ? "#e00" : "#111",
                        fontSize: "18px",
                        lineHeight: 1,
                      }}
                    >
                      {parsed.suit}
                    </Typography>
                  </Box>
                );
              })}
              {winner === "PLAYER_B" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <TrophySVG />
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        <Box className={styles.divider} />

        {/* Winner Info */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            padding: "4px 0",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", gap: "6px" }}>
            <Typography
              sx={{
                fontSize: "13px",
                color: "#555",
                width: "100px",
                textAlign: "right",
              }}
            >
              Winner:
            </Typography>
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 700,
                color: winner === "PLAYER_A" ? "#1976d2" : "#d32f2f",
                width: "100px",
                textAlign: "left",
              }}
            >
              {winner.replace("_", " ")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default TeenPatiTtweentyResultPopup;
